import { useEffect, useRef } from 'react';

const GENERIC_PADDING_HEIGHT = 24;

const clientRect = (element) => {
  try {
    return element.getBoundingClientRect();
  } catch(e) {
    return { height: 0 };
  }
};

export const useTabDetailsInlineHeight = ({
  tab,
  selector = {
    targetElement: '',
  },
  selectors = [],
  totalNoOfGenericPaddings = 3,
  delay = 300, // in milliseconds
  maxCounter = 60,
}) => {
  const resizeTimer = useRef(0);
  const resizeValueChange = useRef(new Map([
    ['', 0],
  ]));

  const handleWindowResize = () => {
    const targetElement = document.querySelectorAll(selector.targetElement);
    const elements = selectors.map((selector) => document.querySelector(selector));
    const clientRects = elements.map(clientRect);
    const totalClientRect = clientRects.reduce((a, b) => ({ height: a.height + b.height }), { height: 0 });

    const maxHeight = `
      calc(100vh - ${
        totalClientRect.height +
        GENERIC_PADDING_HEIGHT * totalNoOfGenericPaddings
      }px)`;

    if (!resizeValueChange.current.has(maxHeight)) {
      resizeValueChange.current.set(maxHeight, 0);
    }
    const counter = resizeValueChange.current.get(maxHeight);
    resizeValueChange.current.set(maxHeight, counter + 1);

    /*
     * @description checks for ui changes
     * delay * maxCounter = total milliseconds
     */
    if (counter >= maxCounter) {
      clearInterval(resizeTimer.current);
    }

    targetElement.forEach((target) => {
      target.setAttribute('style', `max-height:${maxHeight};min-height:${maxHeight}`);
    });
  };

  useEffect(() => {
    if (resizeTimer.current) clearInterval(resizeTimer.current);
    resizeTimer.current = setInterval(handleWindowResize, delay);

    return () => {
      clearInterval(resizeTimer.current);
    };
  }, [tab]);
};

export default useTabDetailsInlineHeight;
